import {
  Theme, styled, Typography
} from '@mui/material'

import { DataGridPro, DataGridProProps } from '@mui/x-data-grid-pro'
import React from 'react'
import { useTranslation } from 'react-i18next'

const StyledDataGrid = styled(DataGridPro)(({ theme }: { theme?: Theme }) => ({
  overflow: 'hidden',
  '& .MuiDataGrid-columnHeaderWrapper, & .MuiDataGrid-columnsContainer': {
    maxHeight: '38px !important',
    minHeight: '38px !important',
    lineHeight: '38px !important'
  },
  '& .MuiDataGrid-renderingZone': {
    maxHeight: 'none !important'
  },
  '& .MuiDataGrid-cell[data-field=user_name_with_image_and_email]': {
    justifyContent: 'flex-start !important'
  },
  '& .MuiDataGrid-cell': {
    // lineHeight: 'unset !important',
    // display: 'flex !important',
    // // justifyContent: 'center !important',
    // alignItems: 'center !important',
    // whiteSpace: 'normal',
    // textAlign: 'left'
  },
  '& .MuiDataGrid-row': {
    maxHeight: 'none !important'
  },
  '& .MuiDataGrid-viewport': {
    maxHeight: 'none !important',
    backgroundColor: 'background.paper'
  },
  '& .MuiDataGrid-window': {
    height: 'unset !important',
    position: 'relative !important',
    top: '38px !important'
  },
  '& .MuiDataGrid-windowContainer': {
    height: 'unset !important',
    position: 'relative !important',
    paddingBottom: '38px'
  },
  '& .MuiDataGrid-columnsContainer': {
    zIndex: '100'
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: theme?.palette.primary.main,
    color: 'white'
  },
  '& .MuiDataGrid-columnHeader': {
    borderRight: 'none !important'
  },
  '& .MuiDataGrid-columnSeparator': {
    visibility: 'hidden'
  },
  '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
    borderRight: `1px solid ${
      theme?.palette.mode === 'light' ? '#f0f0f0' : '#303030'
    }`
  },
  '& .MuiDataGrid-window::-webkit-scrollbar,.MuiDataGrid-virtualScroller::-webkit-scrollbar ':
    {
      display: 'none'
    }
}))

const XGrid: ReactFC<DataGridProProps> = ({ components, ...props }) => {
  const { t } = useTranslation()
  return (
    <StyledDataGrid
      components={{
        NoRowsOverlay: () => <Typography>{t('texts.No_data_available')}</Typography>,
        ...components
      }}
      {...props}
    />
  )
}
export default XGrid
